import { Button, ConfigProvider, message, Upload } from "antd"
import Utils from "@utils/utils"
import { useCallback, useContext, useEffect, useMemo, useState } from "react"
import styles from "./index.module.scss"
import eventBus from '@utils/eventBus'
import { RESOURCE_TYPE } from '@utils/CONST'

const UploadCard = (props) => {
    const {
        children,
        // 上传提示
        dragTips,
        // 内边距
        paddingInline = 25,
        // 多文件上传
        multiple = false,
        // 资源类型，用于触发sendUrlToCustomMaterial
        resourceType,
        // 上传回调
        onUpload,
        // 禁用
        disabled,
        // 加载状态
        loading,
        // 加载状态回调
        setLoading,
    } = props

    useEffect(() => {
        const sendUrlToCustomMaterial = async (params) => {
            if (!resourceType) return
            if (resourceType != params.resourceType) return
            try {
                setLoading(true)
                await onUpload(params.url, [params.url])
            } catch (err) {
                console.error(err)
                return false
            } finally {
                setLoading(false)
            }
        }
        eventBus.on("sendUrlToCustomMaterial", sendUrlToCustomMaterial)
        return () => {
            eventBus.off("sendUrlToCustomMaterial", sendUrlToCustomMaterial)
        }
    }, [])

    // 上传状态
    // const [loading, setLoading] = useState(false)
    const uploadDebounce = useCallback(_.debounce(async (file, fileList) => {
        if (fileList.length > 20) {
            message.warning(`最多上传20张图片，已自动忽略超出部分`)
            fileList = fileList.slice(0, 20)
        }
        setLoading(true)
        try {
            await onUpload(file, fileList)
        } catch (err) {
            message.warning(err.message || String(err))
            return false
        } finally {
            setLoading(false)
        }
    }, 100), [])
    const handleUpload = async (file, fileList) => {
        if (loading) return false
        uploadDebounce(file, fileList)
        return false
    }
    const handleDrop = async (e) => {
        debounceSetIsDraging(false)
        if (loading) return false
        if ("getFilesAndDirectories" in e.dataTransfer) {
            const filesAndDirs = await e.dataTransfer.getFilesAndDirectories()
            const fileList = await Utils.getFilesFromDirs(filesAndDirs, "/")
            console.log('===handleDrop===')
            uploadDebounce(fileList[0], fileList)
            return false
        }
    }

    // 文件拖拽状态
    const [isDraging, setIsDraging] = useState(false)
    // 拖拽状态 debounce
    const debounceSetIsDraging = useCallback(_.debounce(setIsDraging, 100), [])
    // 拖拽状态
    const handleDragOver = (e) => {
        e.preventDefault()
        if (uploadDisabled) return
        setIsDraging(true)
        debounceSetIsDraging(true)
    }
    // 拖拽离开状态
    const handleDragLeave = (e) => {
        e.preventDefault()
        debounceSetIsDraging(false)
    }
    // 上传禁用
    const uploadDisabled = useMemo(() => {
        return loading || disabled
    }, [loading, disabled])

    return (
        <ConfigProvider
            theme={{
                components: {
                    Button: {
                        /* 这里是你的组件 token */
                        paddingInline: paddingInline
                    },
                },
            }}
        >
            <Upload.Dragger
                className={styles.SingleUploader}
                accept={resourceType == RESOURCE_TYPE.VIDEO_MODEL ? 'video/mp4' :
                    'image/jpeg,image/png,image/webp,image/avif'}
                listType="picture-card"
                beforeUpload={handleUpload}
                showUploadList={false}
                multiple={multiple}
                maxCount={30}
                onDrop={handleDrop}
                disabled={uploadDisabled}
            >
                <div
                    className={styles.UploaderContainer}
                    onDragOverCapture={handleDragOver}
                    onDragLeaveCapture={handleDragLeave}
                >
                    {
                        children
                    } {
                        loading &&
                        <div className={styles.ContentWhenUploading}>
                            正在上传...
                        </div>
                    } {
                        <div className={`${styles.ContentWhenDrop} ${isDraging ? styles.ContentWhenDropActive : ''}`}>
                            <span>{dragTips}</span>
                        </div>
                    }
                </div>
            </Upload.Dragger>
        </ConfigProvider>
    )
}

export default UploadCard
